import * as React from 'react';
import S from './SplitContent.styles';
import ImageMask from '@stories/Components/Global/ImageMask/ImageMask';
import { getSrcs } from '@helpers/image';
import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import SectionTitle from '@stories/Components/Global/SectionTitle/SectionTitle';
import VideoModal from '@stories/Components/Global/VideoModal/VideoModal';
import SvgPlay from '@img/icons/circle_play.svg';
import Button, { LinkButton } from '@stories/Components/Buttons/GeneralButton/Button';
import { SystemIcon, getSvgFromSystem } from '@helpers/systemIcons';
const SplitContent = ({ cta, image, intro, mediaAlignment = 'right', sectionTitle, title, titleTheme = 'dark', video, translations, }) => {
    const [showModal, setShowModal] = React.useState(false);
    const srcs = getSrcs(image, 1100, 800, 8, 800 / 1100);
    return (React.createElement(S.Container, { "data-media-alignment": mediaAlignment, "data-is-video": video ? true : false },
        React.createElement(SectionWrapper, null,
            sectionTitle && React.createElement(SectionTitle, { ...sectionTitle }),
            React.createElement(S.Grid, null,
                React.createElement(S.ContentArea, null,
                    React.createElement(S.Title, { "data-title-theme": titleTheme }, title),
                    React.createElement(S.Intro, { dangerouslySetInnerHTML: { __html: intro } }),
                    cta?.url && (React.createElement(LinkButton, { branding: "black", styleType: "outline", title: cta?.text ?? 'Find out more', href: cta?.url, target: cta?.target, addon: cta.icon ? getSvgFromSystem(cta.icon) : getSvgFromSystem(SystemIcon.ArrowRight), addonPosition: "left" })),
                    video && (React.createElement(React.Fragment, null,
                        React.createElement(Button, { branding: "pink", styleType: "solid", title: video.btnText ?? 'Watch our story', addon: video.icon
                                ? getSvgFromSystem(video.icon)
                                : getSvgFromSystem(SystemIcon.CirclePlay), addonPosition: "left", onClick: (event) => {
                                event.preventDefault();
                                setShowModal(true);
                            } }),
                        React.createElement(S.PlayBg, null,
                            React.createElement(SvgPlay, null))))),
                (video || image.src) && (React.createElement(S.MediaArea, null,
                    React.createElement(S.MediaHolder, null,
                        React.createElement(S.ShapeShadow, null),
                        React.createElement(ImageMask, { mask: mediaAlignment === 'right' ? 'arrow' : 'arrow-reverse' },
                            image && image.src && (React.createElement(S.Image, { alt: image.altText ?? '', loading: "lazy", role: image.altText ? undefined : 'presentation', src: srcs[0], srcSet: srcs.join(','), width: "1100", height: "800" })),
                            video ? (React.createElement(S.PlayButton, { "aria-label": "Play Video", type: "button", onClick: (event) => {
                                    event.preventDefault();
                                    setShowModal(true);
                                } },
                                React.createElement(SvgPlay, null))) : (React.createElement(S.BurnOverlay, null)))))))),
        video && (React.createElement(VideoModal, { isVisible: showModal, closeBtnTxt: translations['hyve.global.close-btn'] ?? 'Close', url: video.url, youtubeUrl: video.youtubeUrl, onClick: () => {
                setShowModal(!showModal);
            } }))));
};
export default SplitContent;
